import { render, staticRenderFns } from "./OpenShareFileDialog.vue?vue&type=template&id=484e85ed&scoped=true&"
import script from "./OpenShareFileDialog.vue?vue&type=script&lang=js&"
export * from "./OpenShareFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpenShareFileDialog.vue?vue&type=style&index=0&id=484e85ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e85ed",
  null
  
)

export default component.exports